const x = 2;


const g = 5;